export const SET_WITHDRAWAL_LIMIT = "SET_WITHDRAWAL_LIMIT";
export const SET_WITHDRAWAL_LIMIT_START = "SET_WITHDRAWAL_LIMIT_START";
export const SET_WITHDRAWAL_LIMIT_FAILED = "SET_WITHDRAWAL_LIMIT_FAILED";
